// extracted by mini-css-extract-plugin
export default {"spaceCardSkeleton":"styles_spaceCardSkeleton__Z+1On","stripedShine":"styles_stripedShine__+0JhD"};